module.exports = __webpack_public_path__ + "img/waterspots.8f9dfc15.jpeg";